import React, { useContext, useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { DomainWhitelistSettings, RetentionSettings, ThemeSettings } from './components';
import styles from './styles';
import { AppContext } from '../../context';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 16 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `settings-tab-${index}`,
    'aria-controls': `settings-tabpanel-${index}`,
  };
}

const SettingsPage: React.FC = () => {
  const { isAdmin } = useContext(AppContext);
  const [tabValue, setTabValue] = useState(0);
  const tabs = [
    { label: 'Theme Settings', content: <ThemeSettings /> },
    ...(isAdmin ? [{ label: 'Retention Settings', content: <RetentionSettings /> }] : []),
    ...(isAdmin ? [{ label: 'Domain Whitelist', content: <DomainWhitelistSettings /> }] : [])
  ];

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    console.log(newValue);
    setTabValue(newValue);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="settings tabs"
          sx={styles.tabs}
        >
          {tabs.map((tab, index) => (
            <Tab key={tab.label} label={tab.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      {tabs.map((tab, index) => (
        <TabPanel key={tab.label} value={tabValue} index={index}>
          {tab.content}
        </TabPanel>
      ))}
    </Box>
  );
};

export default SettingsPage; 